module.exports = __webpack_public_path__ + "static/media/img_skill_validation_04.ab98f820.png";